import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  public Login() {
    //this.router.navigate(['/dashboard']);
    //this.router.navigate(['/lighthouse-dasbhoard']);
    window.location.href = environment.azureB2CUrl;
  }
}
